// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/typedef */
import React from 'react';
import ReactDOM from 'react-dom';
import { SylController, SylApi } from '@syllepsis/adapter';
import { Modal, Button, Input, Toast } from '@douyinfe/semi-ui';
import styled from '@jupiter/plugin-runtime/styled';

const Icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    viewBox="0 0 24 24"
    width="20">
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"></path>
  </svg>
);

function XiguaSuffix(): React.ReactElement {
  const viewExample = () => {
    window.open(
      'https://www.feishu.cn/hc/zh-CN/articles/360049067906',
      '_blank',
    );
  };
  return <Button onClick={viewExample}>如何获取链接</Button>;
}

function XiguaTitleModal(props: {
  insertExample: () => void;
}): React.ReactElement {
  const { insertExample } = props;
  return (
    <>
      <span>粘贴西瓜视频链接</span>
      <Button onClick={insertExample}>查看示例</Button>
    </>
  );
}

export class VideoController extends SylController {
  public modalVisible: boolean = false;

  public modalInstance: any | null = null;

  public toolbar = {
    className: 'video',
    tooltip: 'video',
    icon: Icon,
    handler: () => {
      this.modalVisible = true;
      let inputRef: any | null = null;
      const info = Modal.info({
        title: (
          <XiguaTitleModal
            insertExample={() => {
              this.editor.insertCard('video', {
                src: 'https://www.ixigua.com/iframe/6763174234282787341?autoplay=0',
              });
              info.destroy();
            }}
          />
        ),
        content: (
          <XiguaLinkInput>
            <Input
              addonAfter={<XiguaSuffix />}
              ref={el => {
                if (el) {
                  inputRef = el;
                }
              }}
            />
          </XiguaLinkInput>
        ),
        onOk: () => {
          if (!inputRef) {
            return;
          }
          const src = inputRef.value;

          if (!src) {
            Toast.error('无效链接');
            return;
          }

          const match = /https:\/\/www.ixigua.com\/(\d+)/.exec(src);

          if (!match) {
            Toast.error('无效链接');
            return;
          }
          if (match[1]) {
            const transformSrc = `https://www.ixigua.com/iframe/${match[1]}`;
            this.editor.insertCard('video', { src: transformSrc });
          } else {
            Toast.error('无效链接');
          }
        },
      });
    },
  };

  constructor(editor: SylApi, store: any) {
    super(editor, store);
    const extraDom = (
      <Modal title="粘贴西瓜视频链接" visible={this.modalVisible} />
    );
    const modalWrapper = document.createElement('div');
    document.body.appendChild(modalWrapper);
    ReactDOM.render(extraDom, modalWrapper);
  }
}

const XiguaLinkInput = styled.div`
  .addafter {
    padding: 0 !important;
    border: none !important;
  }
`;
